module.exports = __webpack_public_path__ + "static/img/pdd.07cf71e3.png";